import React, { ChangeEvent, Component } from "react";
import PropTypes from "prop-types";
import IRebate from "../../../../../models/IRebate";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwTranslate from "../../../../shared/OwTranslate/OwTranslate";

type Props = {
    rebate: IRebate;
    index: number;
    cancelFn: (index: number) => void;
};

type State = {
    editMode: boolean;
    rebate: IRebate;
    pendingChanges: boolean;
};

class RebateTierRow extends Component<Props, State> {
    readonly state: State = {
        editMode: this.props.rebate.guid ? false : true,
        rebate: this.props.rebate,
        pendingChanges: false,
    };

    toggleEditMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };

    cancel = () => {
        this.setState(
            {
                rebate: this.props.rebate,
                editMode: false,
            },
            () => {
                this.props.cancelFn(this.props.index);
            }
        );
    };

    handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name;
        const value = e.target.value;

        const rebate = this.state.rebate;

        // @ts-expect-error
        rebate[name] = value;

        this.setState({
            rebate,
            pendingChanges: true,
        });
    };

    render() {
        return (
            <div className="RebateTierRow d-flex flex-column">
                <div>
                    {this.state.editMode ? (
                        <div className={"d-inline-flex align-items-center"}>
                            <span className={"text-success me-3 pointer"} onClick={this.toggleEditMode}>
                                <i className={"fas fa-check me-1"}></i> <OwTranslate defaultMessage={"confirm"} id={"confirm"} />
                            </span>
                            <span className={"text-danger pointer"} onClick={this.cancel}>
                                <i className={"fas fa-times me-1"}></i> <OwTranslate defaultMessage={"cancel"} id={"cancel"} />
                            </span>
                        </div>
                    ) : (
                        <div>
                            <span className={"text-primary pointer"} onClick={this.toggleEditMode}>
                                <i className={"fas fa-pencil me-1"}></i> <OwTranslate defaultMessage={"edit"} id={"edit"} />
                            </span>
                        </div>
                    )}
                </div>
                <table className={"table table-dark"}>
                    <thead>
                        <tr>
                            <th>
                                <OwLabel title={"percent"} />
                            </th>
                            <th>
                                <OwLabel title={"min_amount"} />
                            </th>
                            <th>
                                <OwLabel title={"max_amount"} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <OwInputWrapper
                                    type={"number"}
                                    name={"percent"}
                                    fn={this.handleChange}
                                    value={this.state.rebate.percent}
                                    editMode={this.state.editMode}
                                />
                            </td>
                            <td>
                                <OwInputWrapper
                                    type={"number"}
                                    name={"min_amount"}
                                    fn={this.handleChange}
                                    value={this.state.rebate.min_amount}
                                    editMode={this.state.editMode}
                                />
                            </td>
                            <td>
                                <OwInputWrapper
                                    type={"number"}
                                    name={"max_amount"}
                                    fn={this.handleChange}
                                    value={this.state.rebate.max_amount}
                                    editMode={this.state.editMode}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default RebateTierRow;
